import PropTypes from 'prop-types';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Avatar, Box, Grid, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import TotalIncomeCard from 'ui-component/cards/Skeleton/TotalIncomeCard';

// assets
import PersonIcon from '@mui/icons-material/Person';

/* ================= STYLED CARD ================= */

const CardWrapper = styled(MainCard)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
  color: '#fff',
  overflow: 'hidden',
  position: 'relative',
  borderRadius: theme.spacing(2),
  '& > div': {
    position: 'relative',
    zIndex: 5
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 180,
    height: 180,
    background: theme.palette.primary[800],
    borderRadius: '50%',
    top: -80,
    right: -80,
    opacity: 0.35
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    width: 220,
    height: 220,
    background: theme.palette.primary[700],
    borderRadius: '50%',
    top: -140,
    right: -40,
    opacity: 0.25
  }
}));

/* ================= CARD COMPONENT ================= */

const TotalCustomersCard = ({ isLoading, customerData }) => {
  const theme = useTheme();

  return (
    <>
      {isLoading ? (
        <TotalIncomeCard />
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 3 }}>
            <Grid
              container
              direction="column"
              spacing={1.5}
              alignItems="center"
            >
              {/* Icon */}
              <Grid item>
                <Avatar
                  sx={{
                    width: 56,
                    height: 56,
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    color: '#fff',
                    backdropFilter: 'blur(6px)',
                    boxShadow: '0 6px 14px rgba(0,0,0,0.25)'
                  }}
                >
                  <PersonIcon fontSize="medium" />
                </Avatar>
              </Grid>

              {/* Count */}
              <Grid item>
                <Typography
                  sx={{
                    fontSize: '2.5rem',
                    fontWeight: 700,
                    lineHeight: 1
                  }}
                >
                  {customerData?.length || 0}
                </Typography>
              </Grid>

              {/* Label */}
              <Grid item>
                <Typography
                  sx={{
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    opacity: 0.85,
                    letterSpacing: '0.5px'
                  }}
                >
                  Total Customers
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

/* ================= PROPS ================= */

TotalCustomersCard.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  customerData: PropTypes.array
};

export default TotalCustomersCard;
